var modtabs = function(){
    var scope=".js-mod-tabs";
    ui.ready(
        scope,
        function($elem){
            $elem.find(scope+"__link:first").addClass('is-active');
            $elem.find(scope+'__tab-content-item').hide();
            $elem.find(scope+'__tab-content-item:first').show();
            $elem.find(scope+'__tab-content-item:first').addClass('tab-mobile');
            $elem.find(scope+'__link-mobile-item-fold:first').addClass('is-active');
            $elem.find(scope+'__link-mobile-item-fold:first').addClass('is-unfold');
            var mediaqueryList = window.matchMedia("(max-width: 768px)");
            if(mediaqueryList.matches) {
                //$elem.find(scope+'__tab-content-item:first').hide();
            }


            $elem.find(scope+'__tabs li a').click(
                function(ev){
                ev.stopPropagation();
                $elem.find(scope+'__tabs li a').removeClass('is-active');
                $(this).addClass('is-active');
                $elem.find(scope+'__tab-content-item').hide();

                var activeTab = $(this).attr('href');
                $(activeTab).show();
                return false;
            });

            $elem.find(scope+'__link-mobile-item-fold').click(
                function(ev){
                    ev.stopPropagation();
                    $elem.find(scope+'__link-mobile-item-fold').removeClass("is-active");
                    $(this).addClass('is-active');
                    $(this).toggleClass("is-unfold");
                    if($(this).hasClass("is-unfold")){
                        $elem.find(scope+'__link-mobile-item-fold').removeClass("is-unfold");
                        $elem.find(scope+'__tab-content-item').hide();
                        $(this).addClass("is-unfold")
                        var activeTab = $(this).attr('href');
                        $(activeTab).show();
                    }else{
                        $elem.find(scope+'__tab-content-item').hide();
                    }
                    return false;
                });

        }
    );
}();